import React from "react";
import { useForm } from "react-hook-form";
import { Button, VStack } from "@chakra-ui/react";
import { forgotPassword } from "api/webservice/auth";
import { useToast } from "hooks";
import { Form, Input } from "components";

type FormData = {
  email: string;
};

interface Props {
  callback: () => void;
}

export const ForgotPasswordForm: React.FC<Props> = ({ callback }: Props) => {
  const { handleSubmit, errors, register, formState } = useForm<FormData>();
  const toast = useToast();

  const validateEmail = (emailValue: string) => {
    if (!emailValue) {
      return "Email is required";
    }
    return true;
  };

  const submitForm = async ({ email }: FormData): Promise<any | null> => {
    await forgotPassword(email)
      .then(() => {
        callback();
      })
      .catch(error => {
        console.log(error.response);
        toast({
          title: "Unable to send reset email",
          description: "Please check email and try again.",
          status: "error"
        });
      });
  };

  return (
    <Form onSubmit={handleSubmit(submitForm)}>
      <VStack spacing={8}>
        <Input
          name="email"
          label="Email address"
          hideLabel
          register={register({ validate: validateEmail })}
          placeholder="Email"
          inputIcon="email"
          errorMessage={errors.email?.message}
        />

        <Button
          disabled={formState.isSubmitting}
          variant="blue"
          size="lg"
          type="submit"
          isFullWidth
        >
          Send recovery link
        </Button>
      </VStack>
    </Form>
  );
};
